import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";

// Generate UUID v4 - simple implementation
const generateUUID = () => {
  // https://stackoverflow.com/a/2117523/355230
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

// Function to extract OS from user agent
const getOS = (userAgent) => {
  if (/windows/i.test(userAgent)) return "Windows";
  if (/mac/i.test(userAgent)) return "MacOS";
  if (/linux/i.test(userAgent)) return "Linux";
  if (/android/i.test(userAgent)) return "Android";
  if (/iphone|ipad|ipod/i.test(userAgent)) return "iOS";
  return "Unknown";
};

const QRTrack = () => {
  const { loc_id } = useParams();
  const [searchParams] = useSearchParams();

  const device_id = searchParams.get("device_id");

  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);

  useEffect(() => {
    // Retrieve or generate persistent device ID
    // let deviceId = localStorage.getItem("device_id");
    // if (!deviceId) {
    //   deviceId = generateUUID();
    //   localStorage.setItem("device_id", deviceId);
    // }

    const screen_size = `${window.screen.width}x${window.screen.height}`;
    const browser = navigator.userAgent;
    const os = getOS(navigator.userAgent);

    const deviceInfo = {
      loc_id,
      screen_size,
      browser,
      os,
      device_id,
      timestamp: new Date().toISOString(),
    };

    // POST to backend
    fetch(`${prodTestUrl || baseUrl}/api/device-info/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(deviceInfo),
    }).catch((err) => {
      console.error("Failed to send device info:", err);
    });

    // 4. Determine current environment
    const isProd = window.location.hostname === "admin.fastest.academy";
    const frontendBaseUrl = isProd
      ? "https://admin.fastest.academy"
      : "https://dev.admin.fastest.academy";

    // Construct the deep link URL (localhost for dev)
    const deepLink = `fastesthealth://track?loc_id=${loc_id}&device_id=${device_id}`;
    const encodedDeepLink = encodeURIComponent(deepLink);

    // Construct the Firebase Dynamic Link
    const dynamicLink = `https://6lkso.app.link/${encodedDeepLink}`;
    console.log({ dynamicLink });

    // Redirect after short delay
    setTimeout(() => {
      window.location.href = dynamicLink;
    }, 500);
  }, [loc_id, prodTestUrl, baseUrl]);

  return (
    <div>
      <h1>Tracking QR... Redirecting</h1>
    </div>
  );
};

export default QRTrack;
